import {Component, Inject, Input, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfService} from '../../conf.service';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {DialogData} from '../../gateway-consumer/create-credential-dialog/create-credential-dialog.component';
import {EmailtemplateService} from '../../emailtemplate.service';
import {FormControl} from '@angular/forms';
import {environment} from '../../../environments/environment';


@Component({
    selector: 'app-create-user-component',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

    emailId: any;
    token: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('partner');
    username: any;
    selected_environments = new FormControl();
    environmentList = [];

    constructor(public platform: LeftpanelComponent, public dialogRef: MatDialogRef<CreateUserComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private confPost: ConfService, private _snackBar: MatSnackBar, public _service: ConnecttocrudService, public emailTemplateInstance: EmailtemplateService) {
    }

    ngOnInit() {
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
            if (response) {

                for (const item of response['body'][0]['environments']) {
                    if (item['type'] !== 'admin') {
                        this.environmentList.push(item['name']);
                    }
                }
            }
        });
    }


    getToken() {
        return new Promise((resolve, reject) => {
            this.confPost.generatePartnerKey(localStorage.getItem('partner'), localStorage.getItem('partner'), localStorage.getItem('partnerKey')).subscribe(data => {
                if (data) {
                    resolve(data['token']);
                }
            });
        });
    }

    async registerUser() {

        if (this.emailId && this.emailId !== undefined && this.username && this.username !== undefined && this.selected_environments.value !== null && this.selected_environments.value.length > 0) {
            this.emailId = this.emailId.trim();
            if ((this.data.users.filter(element => element['email'] === this.emailId)).length === 0) {
                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
                let dt = new Date();
                dt.setMinutes(dt.getMinutes() + 15);
                const temp = localStorage.getItem('partner').split('-');
                const token = await this.getToken();
                let arrayOfEnvironment = [];
                for (const e of this.selected_environments.value) {
                    arrayOfEnvironment.push(
                        {
                            name: e,
                            roles: [],
                            account: e,
                            exclusions: {
                                permissions: [],
                                permission_groups: [],
                                roles: []
                            },
                            audit_logs: [
                                {
                                    action: 'CREATE',
                                    by: localStorage.getItem('signInEmail'),
                                    at: Date.now()
                                }
                            ]
                        }
                    );
                }
                const payload = {
                    email: this.emailId,
                    created_at: Date.now(),
                    created_by: localStorage.getItem('signInEmail'),
                    last_updated_at: Date.now(),
                    last_updated_by: localStorage.getItem('signInEmail'),
                    status: false,
                    user_token: token,
                    partner: temp[temp.length - 1],
                    expires_at: (this.toTimestamp(dt)) * 1000,
                    user: this.username,
                    environments: arrayOfEnvironment,
                    user_groups: []
                };

                if (this.emailId !== localStorage.getItem('signInEmail')) {
                    this._service.addItem(payload, 'v1', environment.accessPartner,  environment.accessPartner, 'users').subscribe(data => {
                        if (data) {

                            this.sendInvite(this.emailId, temp[temp.length - 1], token, this.username);
                            loaderDialog.close();
                            this.dialogRef.close('success');

                        }
                    });
                } else {
                    this.platform.openSnackBar(' User cannot be created', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.platform.openSnackBar(' User already exists', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Please enter valid credentials', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    sendInvite(emailId, partner, token, username) {
        this.emailTemplateInstance.verifyUser.to.value[0].email = emailId;
        this.emailTemplateInstance.verifyUser.to.value[0].partner = partner;
        this.emailTemplateInstance.verifyUser.to.value[0].token = token;
        this.emailTemplateInstance.verifyUser.to.value[0].username = username;
        this.confPost.executeEmail(this.emailTemplateInstance.verifyUser).subscribe(response => {
            this.platform.openSnackBar(' Invitation has been sent  ', 'Success', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }


    closeDialog() {
        this.dialogRef.close();
    }

    toTimestamp(strDate) {
        const datum = Date.parse(strDate);
        return datum / 1000;
    }
}
